import IntLink from 'components/common/IntLink'
import { ICategory, IProduct } from 'store/api'

type Props = {
  product: IProduct
  category: ICategory
}

const ProductPath = ({ product, category }: Props) => {
  return (
    <div className='pb-5 lg:py-8 lg:pr-4 w-full'>
      <div className='text-sm2 leading-5 tracking-tight'>
        <IntLink
          className='text-dark underline hover:text-accent'
          href='/'
        >
          Главная
        </IntLink>
        {' — '}
        <IntLink
          className='text-dark underline hover:text-accent'
          href='/categories'
        >
          Меню
        </IntLink>
        {' — '}
        <IntLink
          className='text-dark underline hover:text-accent'
          href={`/categories/${category.slug}`}
        >
          {category.name}
        </IntLink>
        <span className='text-greyA1'>{` — ${product.name}`}</span>
      </div>
    </div>
  )
}

export default ProductPath
